const STRICT_TRUTHY = new Set(["1", "true", "yes", "y", "on"]);

export function safeString(value) {
  return typeof value === "string" ? value : value == null ? "" : String(value);
}

export function parseStrictTruthy(value) {
  return STRICT_TRUTHY.has(safeString(value).trim().toLowerCase());
}

export function isLegalAcceptanceUiEnabled(env = process.env) {
  return parseStrictTruthy(env.REACT_APP_LEGAL_ACCEPTANCE_UI_ENABLED);
}
